import React from 'react';

import { Chip } from '@mui/material';

import type { Nullable } from '@clearverify/types';

import { UserStatus } from 'src/api';
import { formatUserStatus } from 'src/utils/user';

import 'src/theme/chip';

import { userStatusChipStyles } from './styles';

interface UserStatusChipProps {
  userStatus: Nullable<UserStatus>;
  dataIsDeleted?: boolean;
}

export const UserStatusChip: React.FC<UserStatusChipProps> = ({ userStatus, dataIsDeleted }) => {
  return (
    <Chip
      label={formatUserStatus(userStatus, dataIsDeleted)}
      size="small"
      variant="outlined"
      sx={userStatusChipStyles[userStatus || UserStatus.Inactive]}
    />
  );
};
